<template>
  <li>
    <span>Payment method</span>

    <span class="creditCardForm" style="position: relative">
      <template v-if="is_loading">
        <div class="loading_spinner">
          <img :src="'/images/loading.png'" />
        </div>
      </template>

      <template v-if="edit">
        <div
          class="form-item"
          :class="payment_type === 'cc' ? 'half-width' : ''"
        >
          <label>*Select payment method</label>
          <select
            autocomplete="off"
            required="required"
            id="payment_type"
            name="payment_type"
            :value="payment_type"
            v-on:change="updatePaymentMethod($event)"
          >
            <option value="cc">Credit card</option>
            <option value="checking">E-Check - Personal checking</option>
            <option value="businessChecking">
              E-Check - Business checking
            </option>
            <option value="savings">E-Check - Savings</option>
          </select>
        </div>

        <div class="form-item half-width" v-if="payment_type === 'cc'">
          <i>
            <small style="color: #17355c">
              A 3% credit card fee will be applied to purchases and reoccurring
              subscription payments when using this payment method.
            </small>
          </i>
        </div>

        <template v-if="payment_type === 'cc'">
          <div
            class="form-item"
            v-bind:class="{ 'input-error': warning_card_number }"
          >
            <label>*Card Number</label>
            <input type="text" name="cardNumber" v-model="cardNumber" />
          </div>

          <div
            class="form-item half-width"
            v-bind:class="{ 'input-error': warning_month }"
          >
            <label>*Exp: Month</label>
            <select
              autocomplete="off"
              id="exp_month"
              name="expirationDate"
              class="expiration"
              v-model="expirationMonth"
            >
              <option value="01">January</option>
              <option value="02">February</option>
              <option value="03">March</option>
              <option value="04">April</option>
              <option value="05">May</option>
              <option value="06">June</option>
              <option value="07">July</option>
              <option value="08">August</option>
              <option value="09">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
          </div>

          <div
            class="form-item half-width"
            v-bind:class="{ 'input-error': warning_year }"
          >
            <label>*Exp: Year</label>
            <select
              autocomplete="off"
              id="exp_year"
              name="expirationYear"
              class="expiration"
              v-model="expirationYear"
            >
              <option
                v-for="year in expirationYearDropdown"
                v-bind:key="year"
                :value="year"
              >
                {{ year }}
              </option>
            </select>
          </div>
        </template>

        <template v-else>
          <div class="form-item">
            <label
              for="account_name"
              class="control-label"
              :class="{ 'input-error': warning_account_name }"
            >
              *Account name
            </label>
            <input
              name="account_name"
              type="text"
              id="account_name"
              class="account_name ach_field"
              @input="validateAccountName"
              v-model="account_name"
            />
          </div>

          <div class="form-item half-width">
            <label
              for="routing_number"
              class="control-label"
              :class="{ 'input-error': warning_routing_number }"
            >
              *Routing number
            </label>
            <input
              name="routing_number"
              type="text"
              id="routing_number"
              class="routing_number ach_field"
              v-model="routing_number"
            />
          </div>

          <div class="form-item half-width">
            <label
              for="account_number"
              class="control-label"
              :class="{ 'input-error': warning_account_number }"
            >
              *Account number
            </label>
            <input
              name="account_number"
              type="text"
              id="account_number"
              class="account_number ach_field"
              v-model="account_number"
            />
          </div>
        </template>

        <div class="form-action width-100">
          <div class="double-buttons-right width-100">
            <a v-on:click="cancelClick()" class="button-grey vue-anchor">
              Cancel
            </a>
            <a v-on:click="confirmClick()" class="button-green vue-anchor">
              Confirm
            </a>
          </div>
          <div v-if="haserror">
            <p class="warning">{{ errormessage }}</p>
          </div>
        </div>
      </template>

      <span v-else>
        <template v-if="payment_type === 'cc'">
          {{ cardNumber }}
        </template>
        <template v-else>
          {{ account_number }}
        </template>
        <span v-if="success">Payment Method Updated</span>
      </span>
    </span>
    <span>
      <a class="vue-anchor" @click="editClick()">
        <span class="icon-edit"></span>
        Edit
      </a>
    </span>
  </li>
</template>

<script>
  export default {
    name: 'ClickToEditBillingPaymentComponent',

    props: {
      user_payment_type: {
        type: String,
        default() {
          return 'cc';
        },
      },
      cc_info: {
        type: Object,
        default() {
          return {
            cardNumber: '',
            expirationDate: '',
          };
        },
      },
      ach_info: {
        type: Object,
        default() {
          return {
            accountNumber: '',
            accountType: '',
            echeckType: '',
            nameOnAccount: '',
            routingNumber: '',
          };
        },
      },
    },

    data() {
      return {
        edit: false,
        success: false,
        haserror: false,
        errormessage: '',
        is_loading: false,
        payment_type: this.user_payment_type,

        // cc fields
        cardNumber: this.cc_info.cardNumber,
        expirationMonth: '',
        expirationYear: '',
        warning_year: false,
        warning_month: false,
        warning_card_number: false,
        expirationYearDropdown: [],

        // ach fields
        account_name: this.ach_info.nameOnAccount,
        account_number: this.ach_info.accountNumber,
        routing_number: this.ach_info.routingNumber,
        warning_account_name: false,
        warning_account_number: false,
        warning_routing_number: false,
      };
    },

    mounted() {
      this.expirationYearDropdown = this.expirationYears();
    },

    methods: {
      editClick: function () {
        this.edit = true;
      },
      updatePaymentMethod: function (event) {
        // callback to properly manage fields as user switches payment type
        var payment_type = event.target.value;
        if (payment_type != 'cc') {
          if (payment_type != this.ach_info.accountType) {
            this.account_name = '';
            this.account_number = '';
            this.routing_number = '';
          } else {
            this.account_name = this.ach_info.nameOnAccount;
            this.account_number = this.ach_info.accountNumber;
            this.routing_number = this.ach_info.routingNumber;
          }
        }

        this.payment_type = payment_type;
      },
      confirmClick: function () {
        // set loading configs
        this.success = false;
        this.haserror = false;
        this.errormessage = '';

        // reset errors
        this.warning_year = false;
        this.warning_month = false;
        this.warning_card_number = false;
        this.warning_account_name = false;
        this.warning_account_number = false;
        this.warning_routing_number = false;

        // save new info
        if (this.payment_type === 'cc') {
          this.validateCreditCard();
        } else {
          this.validateBankAccount();
        }
      },
      validateCreditCard: function () {
        const enterFullCardNumber = this.cardNumber.substring(0, 4);
        if (this.cardNumber == '' || enterFullCardNumber === 'XXXX') {
          this.haserror = true;
          this.warning_card_number = true;
          this.errormessage = '*Complete Card Number is Required';
          return;
        }

        if (this.expirationMonth == '') {
          this.haserror = true;
          this.warning_month = true;
          this.errormessage = '*Expiration Month is Required';

          return;
        }

        if (this.expirationYear == '') {
          this.haserror = true;
          this.warning_year = true;
          this.errormessage = '*Expiration Year is Required';
          return;
        }

        // post to server
        this.uploadData();
      },
      validateAccountName: function () {
        this.haserror = false;
        this.warning_account_name = false;
        this.errormessage = '';

        if (this.account_name == '') {
          this.haserror = true;
          this.warning_account_name = true;
          this.errormessage = '*Account name is Required';

          return false;
        }

        if (this.account_name.length > 22) {
          this.haserror = true;
          this.warning_account_name = true;
          this.errormessage =
            '*Account name is too long. Name can be a max of 22 characters.';

          return false;
        }

        return true;
      },
      validateBankAccount: function () {
        if (!this.validateAccountName()) {
          return;
        }

        const enter_routing_number = this.routing_number.substring(0, 4);
        if (this.routing_number == '' || enter_routing_number == 'XXXX') {
          this.haserror = true;
          this.warning_routing_number = true;
          this.errormessage = '*Routing number is Required';

          return;
        }

        const enter_account_number = this.account_number.substring(0, 4);
        if (this.account_number == '' || enter_account_number == 'XXXX') {
          this.haserror = true;
          this.warning_account_number = true;
          this.errormessage = '*Account number is Required';

          return;
        }

        // post to server
        this.uploadData();
      },
      uploadData: function () {
        this.is_loading = true;

        var model = {
          paymentType: this.payment_type,
          setCardNumber: this.cardNumber,
          setExpirationDate: this.expirationYear + '-' + this.expirationMonth, // yyyy-MM format
          setNameOnAccount: this.account_name,
          setRoutingNumber: this.routing_number,
          setAccountNumber: this.account_number,
          setEcheckType: this.payment_type == 'businessChecking' ? '' : 'WEB',
        };

        axios
          .post('/authnet/update-customer-payment-profile', model)
          .then((success) => {
            this.is_loading = false;
            if (success.data.data.messages.resultCode == 'Error') {
              const message = success.data.data.messages.message;
              this.success = false;
              this.haserror = true;
              this.errormessage = message.text;
            } else if (success.data.data.messages.resultCode !== 'Error') {
              this.success = true;
              this.edit = false;
              if (this.payment_type === 'cc') {
                var str = this.cardNumber;
                var trailingCharsIntactCount = 4;
                str =
                  new Array(str.length - trailingCharsIntactCount + 1).join(
                    'x'
                  ) + str.slice(-trailingCharsIntactCount);
                this.cardNumber = str;

                this.account_name = '';
                this.account_number = '';
                this.routing_number = '';
              } else {
                var trailingCharsIntactCount = 4;
                var acc = this.account_number;
                acc =
                  new Array(acc.length - trailingCharsIntactCount + 1).join(
                    'x'
                  ) + acc.slice(-trailingCharsIntactCount);
                this.account_number = acc;

                var rt = this.routing_number;
                rt =
                  new Array(rt.length - trailingCharsIntactCount + 1).join(
                    'x'
                  ) + rt.slice(-trailingCharsIntactCount);
                this.routing_number = rt;

                this.cardNumber = '';
              }
            }

            this.expirationMonth = '';
            this.expirationYear = '';
            this.warning_year = false;
            this.warning_month = false;
            this.warning_card_number = false;
            this.warning_account_name = false;
            this.warning_account_number = false;
            this.warning_routing_number = false;

            this.$emit('getCurrentProfile');
          })
          .catch((error) => {
            this.is_loading = false;
            this.haserror = true;
            this.errormessage =
              'Error saving payment method. Please contact support.';
          });
      },
      cancelClick: function () {
        // reset to defaults
        this.edit = false;
        this.success = false;
        this.haserror = false;
        this.errormessage = '';
        this.is_loading = false;
        this.payment_type =
          this.ach_info.accountType != '' ? this.ach_info.accountType : 'cc';
        // cc fields
        this.cardNumber = this.cc_info.cardNumber;
        this.expirationMonth = '';
        this.expirationYear = '';
        this.warning_year = false;
        this.warning_month = false;
        this.warning_card_number = false;
        // ach fields
        this.account_name = this.ach_info.nameOnAccount;
        this.account_number = this.ach_info.accountNumber;
        this.routing_number = this.ach_info.routingNumber;
        this.warning_account_name = false;
        this.warning_account_number = false;
        this.warning_routing_number = false;
      },
      expirationYears: function () {
        var current_year = new Date().getFullYear();

        var years = [];
        for (var i = 0; i < 10; i++) {
          years.push(current_year + i);
        }

        return years;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
